<template>
  <v-list two-line>
    <template v-for="(item,index) in items">
      <v-list-tile :key="index" class="activity-stats">
        <v-list-tile-avatar>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="item.title"></v-list-tile-title>
          <v-list-tile-sub-title v-html="item.info"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'activity-stats',
  props: {
    activity: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data: () => ({
    items: [],
  }),
  watch: {
    activity() {
      this.generateItems();
    },
  },
  mounted() {
    this.generateItems();
  },
  methods: {
    generateItems() {
      if (this.activity) {
        const props = [];
        props.push({ title: this.$bc.fromNow(this.activity.start_date), icon: 'schedule', info: this.$bc.dateFormat(this.activity.start_date, 'dddd DD/MMM/YYYY @ HH:mm') });
        const pm = this.activity.elapsed_time > 0 ? (this.activity.moving_time * 100) / this.activity.elapsed_time : 0;
        const info = `${this.$bc.timeFormat(this.activity.elapsed_time)} (${pm.toFixed(0)}% moving)`;
        props.push({ title: 'Duration', icon: 'timer', info });
        const avgSpeed = this.$bc.speedFormat(this.activity.average_speed);
        const maxSpeed = `(${this.$bc.speedFormat(this.activity.max_speed)} max)`;
        props.push({ title: 'Average speed', icon: 'play_arrow', info: `${avgSpeed} ${maxSpeed}` });
        props.push({ title: 'Distance', icon: 'straighten', info: this.$bc.distanceFormat(this.activity.distance, 'major') });
        props.push({ title: 'Elevation', icon: 'landscape', info: this.$bc.elevationFormat(this.activity.total_elevation_gain) });
        props.push({ title: 'Kudos', icon: 'thumb_up', info: this.activity.kudos_count });
        this.items = props;
      }
    },
  },
};
</script>
<style lang="scss">
.activity-stats {
  .v-list__tile {
    height: 50px;
  }
}
</style>


